<template>
<div class="chapter">
<div class="inner_page">
<p class="fmtitle1"><a id="page_xv">The War Comes to Plum Street</a></p><a id="page_xv">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 09_Fm01.vue?04a71d2f